export default __webpack_public_path__ + "static/media/blur-cover.0d439c13.jpg";